import noRigth from "../img/no_right.png";

const NoRight = () => {
  return (
    <div className="no_rigth_container">
      <img src={noRigth} alt="" />
      <p className="no_rigth_message">Нет прав доступа для просмотра функционала, обратитесь администратору личного кабинета.</p>
    </div>
  );
};
export { NoRight };
